


export function polygonTop(polygon: number[]): number {
  return polygon
    .filter((_, i) => i % 2 !== 0)
    .reduce((acc, y) => Math.min(acc, y), Number.MAX_SAFE_INTEGER);
}

export function polygonBottom(polygon: number[]): number {
  return polygon
    .filter((_, i) => i % 2 !== 0)
    .reduce((acc, y) => Math.max(acc, y), Number.MIN_SAFE_INTEGER);
}

export function polygonLeft(polygon: number[]): number {
  return polygon
    .filter((_, i) => i % 2 === 0)
    .reduce((acc, y) => Math.min(acc, y), Number.MAX_SAFE_INTEGER);
}

export function polygonCrossingsY(polygon: number[], y: number): number[] {
  const crossings: number[] = [];

  // Iterate through each edge of the polygon
  for (let i = 0; i < polygon.length; i += 2) {
      const x1 = polygon[i];
      const y1 = polygon[i + 1];
      const x2 = polygon[(i + 2) % polygon.length];
      const y2 = polygon[(i + 3) % polygon.length];

      // Check if the edge crosses the given y value
      if ((y1 < y && y2 >= y) || (y2 < y && y1 >= y)) {
          // Calculate the x-coordinate of the intersection
          const t = (y - y1) / (y2 - y1);
          const x = x1 + t * (x2 - x1);
          crossings.push(x);
      }
  }

  return crossings.sort((a, b) => a - b);
}
